<template>
  <div>
    <v-container :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''">
      <v-card flat style="margin-top: 8px;padding:15px;">
        <v-col lg="12" style="padding:8px">
          <v-row>
            <v-col lg="3" style="padding:8px">
              <div class="my-2">
                <v-btn text v-bind:color="active == 0 ? '#4dbac0' : 'white' " @click="swap(0)">
                  <span style="position:relative;left:0px">
                    <v-icon dark>assignment_ind</v-icon>
                    <span class="ml-2">Personal Data</span>
                  </span>
                </v-btn>
              </div>
              <div class="my-2">
                <v-btn
                  disabled
                  text
                  v-bind:color="active == 1 ? '#4dbac0' : 'white' "
                  @click="swap(1)"
                >
                  <v-icon dark>lock_outline</v-icon>
                  <span class="ml-2">Security</span>
                </v-btn>
              </div>


              <div class="my-2">
                <v-btn
                  text
                  v-bind:color="active == 5 ? '#4dbac0' : 'white' "
                  @click="swap(5)"
                >
                  <v-icon dark>laptop_windows</v-icon>
                  <span class="ml-2">My Platforms</span>
                </v-btn>
              </div>



              <div class="my-2">
                <v-btn text v-bind:color="active == 2 ? '#4dbac0' : 'white' " @click="swap(2)">
                  <v-icon dark>account_tree</v-icon>
                  <span class="ml-2">Connectivity</span>
                </v-btn>
              </div>

              <div class="my-2">
                <v-btn text v-bind:color="active == 6 ? '#4dbac0' : 'white' " @click="swap(6)">
                  <v-icon dark>backspace</v-icon>
                  <span class="ml-2">Reset Data</span>
                </v-btn>
              </div>


              <div class="my-2">
                <v-btn
                  disabled
                  text
                  v-bind:color="active == 3 ? '#4dbac0' : 'white' "
                  @click="swap(3)"
                >
                  <v-icon dark>share</v-icon>
                  <span class="ml-2">Sharing</span>
                </v-btn>
              </div>
              <div class="my-2">
                <v-btn
                  disabled
                  text
                  v-bind:color="active == 4 ? '#4dbac0' : 'white' "
                  @click="swap(4)"
                >
                  <v-icon dark>payment</v-icon>
                  <span class="ml-2">Payments</span>
                </v-btn>
              </div>


              <v-divider class="my-4" ></v-divider>

              <div class="my-2">
                <v-btn
                  disabled
                  text
                  v-bind:color="active == 7 ? '#4dbac0' : 'white' "
                  @click="swap(7)"
                >
                  <v-icon dark>help_outline</v-icon>
                  <span class="ml-2">Help</span>
                </v-btn>
              </div>


            </v-col>
            <v-col lg="9" style>
              <transition name="component-fade" mode="out-in">
                <component :is="dynamicComponent[active]" @edit="onClickEdit"></component>
              </transition>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import PersonalData from "./PersonalData";
import ResetData from "./ResetData";
import Connectivity from "./Connectivity";
import Security from "./Security";
import Sharing from "./Sharing";
import Payments from "./Payments";
import PlatformAccount from "./PlatformAccount";

export default {
  name: "Settings",
  components: {},
  data() {
    return {
      active: 0,
      edit: 0,
      dynamicComponent: [
        PersonalData,
        Security,
        Connectivity,
        Sharing,
        Payments,
        PlatformAccount,
        ResetData
      ]
    };
  },
  methods: {
    swap(val) {
      this.active = val;
      this.edit = 0;
    },
    onClickEdit(val) {
      this.edit = val;
    }
  }
};
</script>

<style>
</style>